export default "__VITE_ASSET__1f58687c__"